<template>
	<div class="customizer-section" :class="{ 'is-expanded': expanded }">
		<div class="section-title">
			<span v-if="$slots.icon" class="section-title-icon">
				<slot name="icon"></slot>
			</span>

			<span class="section-title-text">{{ title }}</span>

			<button class="section-title-expand" @click.prevent="expanded = !expanded"><i class="fas fa-chevron-down"/></button>
		</div>

		<div v-show="expanded" class="section-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: { type: String, required: true },
	},

	data() {
		return {
			expanded: true,
		}
	}
}
</script>